export default __webpack_public_path__ + "static/2433-4ab21192a75526c4948b33ace82aa1c2.gif";